import { deleteUser, UserDataType, UsersUpdateType, useUpdateAccountUsers } from '@ukpostbox/client-data';
import { Button, ColourStateSolid, Modal, ModalType, useTranslation } from '@ukpostbox/frontend-framework';
import { useState } from 'react';

interface ConfirmDeleteUserType extends ModalType {
	user: UserDataType;
}

function ConfirmDeleteUserModal(props: ConfirmDeleteUserType) {
	const { t } = useTranslation();
	const updateUsers = useUpdateAccountUsers();
	const [deletingUser, setDeletingUser] = useState<boolean>(false);

	const HandleDelete = async (userId: number) => {
		if (userId === -1) return;

		setDeletingUser(true);

		await deleteUser(userId)
			.then((r) => {
				updateUsers.mutate({
					updateType: UsersUpdateType.REMOVE,
					newData: userId,
				});

				props.closeCallback();
			})
			.catch((e) => {
				console.error(e.response.data);
			})
			.finally(() => setDeletingUser(false));
	};

	return (
		<Modal
			title={t('actions.deleteItem', { item: props.user?.name })}
			isOpen={props.isOpen}
			closeCallback={() => props.closeCallback()}
		>
			<p>{t('messages.deleteConfirm')}</p>
			<Button
				title={t('actions.delete')}
				loading={deletingUser}
				colour={ColourStateSolid.Alert}
				fullWidth
				onClick={() => HandleDelete(props.user?.userId ?? -1)}
			/>
		</Modal>
	);
}

export default ConfirmDeleteUserModal;
